import { REACT_PROPS_REGEXP } from './constants';
export var isReactProp = function isReactProp(propName) {
  return REACT_PROPS_REGEXP.test(propName);
};